module.exports = __webpack_public_path__ + "static/media/cq_freccia_su b.bd470935.svg";